module.exports = __webpack_public_path__ + "img/14.b7f2f0e3.png";